/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'


export function Main(props) {
  const { nodes, materials } = useGLTF('/meshes/main_scene5-v7-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.floor.geometry} material={materials.floor} position={[-0.01, 0, -0.61]} />
      <mesh geometry={nodes.Snow.geometry} material={materials.Snow} position={[0, 0, -0.61]} />
      <mesh geometry={nodes.objects.geometry} material={materials.objects} position={[1.13, 0.28, 0.53]} rotation={[-Math.PI, -0.09, -Math.PI]} />
      <mesh 
        // onClick={() => {console.log('frame clicked')}}
        geometry={nodes.frame.geometry} material={materials.frame} position={[-0.02, 1.27, -1.89]} rotation={[Math.PI, -0.02, Math.PI]} />
      <mesh 
        onClick={() => props.setModalIsOpen(true)}
        geometry={nodes.photo.geometry} material={materials.photo} position={[-0.02, 1.24, -1.89]} rotation={[Math.PI, -0.02, Math.PI]} scale={0.09} />
      <mesh geometry={nodes.glass.geometry} material={materials.glass} position={[-0.02, 1.27, -1.89]} rotation={[0, 0.02, 0]} />
    </group>
  )
}

useGLTF.preload('/meshes/main_scene5-v7-transformed.glb')
